import excelIcon from "../../../../assets/images/excel-file-icon.svg";
import zipIcon from "../../../../assets/images/zipIcon.svg";
import pdfIcon from "../../../../assets/images/pdf-dual-color.svg";

export const DrawerConstants = {
  TITLE: "All Forms",
  WIDTH: "30%",
  BUTTON_LABEL: "Download All",
};

export const drawerContents = {
  batchSummaryExcelFileUrl: ["Batch summary", excelIcon, "batch_summary.xls"],
  ticketsPDFfileUrl: ["Ticket Images", pdfIcon, "Tickets.pdf"],
  batchSummaryPdfFileUrl: [
    "Batch summary & Ticket images",
    pdfIcon,
    "Tickets_and_Batch_Summary.pdf",
  ],
  rateAgreementDocs: ["Original Contract", pdfIcon, "Rate_agreement_"],
  documentsZipUrl: ["Project Supporting Documents", zipIcon, "All forms"],
};
